import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import NewsForm from "views/admin/news/components/NewsForm"
import EventForm from "views/admin/events/components/EventForm"
import UserForm from "views/admin/management/components/UserForm";
import routes from "routes.js";
import CreateNews from "../../views/admin/requests/create";
import EditNews from "../../views/admin/requests/edit";
import CommentsIndexPage from "../../views/admin/comments";
import CategoriesIndexPage from "../../views/admin/categories";
import CreateCategories from "../../views/admin/categories/create";
import EditCategories from "../../views/admin/categories/edit";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("خوش آمدید");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "خوش آمدید";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "rtl";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:mr-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Stat-co Management"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                {/* <Route
                  path="/"
                  element={<Navigate to="default" replace />}
                /> */}
                {/*<Route*/}
                {/*  path="/news/add"*/}
                {/*  element={<NewsForm />}*/}
                {/*/>*/}
                <Route
                    path="/news/create"
                    element={<CreateNews />}
                />
                <Route
                  path="/news/edit/:id"
                  element={<EditNews />}
                />


                {/*<Route*/}
                {/*    path="/news/edit/:id"*/}
                {/*    element={<EditNews />}*/}
                {/*/>*/}

                <Route
                    path="/comments"
                    element={<CommentsIndexPage />}
                />

                {/* categories */}
                <Route
                    path="/categories"
                    element={<CategoriesIndexPage/>}
                />
                <Route
                    path="/categories/create"
                    element={<CreateCategories />}
                />
                <Route
                    path="/categories/edit/:id"
                    element={<EditCategories />}
                />


                <Route
                  path="/events/add"
                  element={<EventForm />}
                />
                <Route
                  path="/events/edit/:id"
                  element={<EventForm />}
                />
                <Route
                  path="/management/addUser"
                  element={<UserForm />}
                />

              </Routes>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
